import React from 'react';

const Footer = () => {
    return (
        <footer className="footer card px-4">
            <div className="row gx-5 py-8 px-15">
                <div className="col text-start align-self-center">
                    <img width={100} height={35} src={require('../../../assets/img/logo-lpdp.png')} alt="Logo LPDP" />
                </div>
                <div className="col text-end">
                    <p className='mt-3'>© 2024 LPDP. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;